import React, { Component } from 'react';
import './editalumni.css';
import { Input, Modal, Button, Tabs, Row, Col, Dropdown, Icon, Menu, Collapse, Form, Select, Radio, DatePicker, Checkbox } from 'antd';
import moment from 'moment';
const TabPane = Tabs.TabPane;
const FormItem = Form.Item;
const Panel = Collapse.Panel;


const customPanelStyle = {
    background: '#fff',
    borderRadius: 4,
    marginBottom: 24,
    border: 0,
    overflow: 'hidden',
};

class Financial extends Component {
    render() {
        const dateFormat = 'MM/DD/YYYY';
        return (
            <div>
                <Collapse defaultActiveKey={'1'} accordion style={{ border: 'none', backgroundColor: 'inherit' }}>
                    <Panel header="Financial Highlights" key="1" style={customPanelStyle}>
                        <p>
                            {/* Financial Highlights */}
                            <Form layout="vertical">
                                <Row type="flex" justify="space-between">
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Total Transactions:"
                                        >
                                            <Input disabled={true} placeholder="Total Transactions" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Total Amount Receive:"
                                        >
                                            <Input disabled={true} placeholder="Total Amount Receive" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Total Outstanding Amount:"
                                        >
                                            <Input disabled={true} placeholder="Total Outstanding Amount" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Total Gifts:"
                                        >
                                            <Input disabled={true} placeholder="Total Gifts" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Total Registrations:"
                                        >
                                            <Input disabled={true} placeholder="Total Registrations" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={0} sm={0} md={7} lg={7} xl={7}>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Transaction ID:"
                                        >
                                            <Input disabled={true} placeholder="Transaction ID" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Total Gifts / Registration Amount Receive:"
                                        >
                                            <Input disabled={true} placeholder="Total Gifts" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Total Outstanding Amount:"
                                        >
                                            <Input disabled={true} placeholder="Total Outstanding Amount" />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </p>
                    </Panel>
                    <Panel header="Transactions" key="2" style={customPanelStyle}>
                        <p></p>
                    </Panel>
                    <Panel header="Soft Credits" key="3" style={customPanelStyle}>
                        <p></p>
                    </Panel>
                </Collapse>
                <Row type="flex" justify="center">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form layout="vertical" style={{ padding: "50px 5px 50px 5px" }}>
                            <Row type="flex" justify="space-between">
                                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                    <Button className="cancel-btn" style={{ width: '100%', fontWeight: 600, boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.3)', marginBottom:'10px' }}>Cancel</Button>
                                </Col>
                                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                    <Button style={{ width: '100%', fontWeight: 600, boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.3)', marginBottom:'10px' }} type="primary">Save Changes</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Financial;


// WEBPACK FOOTER //
// ./src/components/MaintainAlumni/Financial.js